module.exports = __webpack_public_path__ + "static/media/YF61_2.3736a81e.jpg";